module.exports = __webpack_public_path__ + "static/media/sports.e8a9a94f.jpg";